// extracted by mini-css-extract-plugin
module.exports = {"switch":"df5dab2e92--switch--Iu4Bo","indicator":"df5dab2e92--indicator--JD6wH","disabled":"df5dab2e92--disabled--WS_Zh"};